export default __webpack_public_path__ + "static/media/evalution.b25c5ab9.png";